import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { OptionService } from 'src/app/options/option.service';
import { Users } from 'src/app/options/users/users.model';
import { AssisDirctChargeService } from './assis-dirct-charge.service';
import { Globle } from 'src/assets/globle';
import { LocalStorageService } from 'ngx-webstorage';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { AssistanceDirectCharge } from './assistanceDirectCharge.model';
import { map, startWith } from 'rxjs/operators';
import { UsersService } from 'src/app/options/users/users.service';

@Component({
  selector: 'app-assistance-directcharge-perm',
  templateUrl: './assistance-directcharge-perm.component.html',
  styleUrls: ['./assistance-directcharge-perm.component.css']
})
export class AssistanceDirectchargePermComponent implements OnInit {

  users: Users[] = [];
  lstCategories: AssistanceDirectCharge[] = [];
  permission: AssistanceDirectCharge = {} as AssistanceDirectCharge;
  displayedColumns: string[] = ['category', 'view'];
  dataSource!: MatTableDataSource<AssistanceDirectCharge>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  spinnerOverlay = false
  selectedRole!: string;
  selectedMenu!: number;
  pageSize = 100;

  filteredOptions!: Observable<Users[]>;
  searchCategory = new FormControl();
  selectedUser!: string;
  constructor(private translate: TranslateService,
    private optionService: OptionService,
    private userService: UsersService,
    private service: AssisDirctChargeService,
    private globle: Globle,
    private localStorage: LocalStorageService,
    private snackBar: MatSnackBar) { }

  ngOnInit(): void {
    this.pageSize = this.globle.pageSize;
    this.getAssistance();
  }

  getAssistance() {
    //let userId = this.localStorage.retrieve("userInfo").userId
    this.userService.getWebAssistanceUsers().subscribe(data => {
      this.users = data
      this.autoCompleatFilter();
    }, error => {
      console.log(error)
    })
  }

  autoCompleatFilter() {
    this.filteredOptions = this.searchCategory.valueChanges
      .pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value.name),
        map(name => name ? this._filter(name) : this.users.slice())
      );
  }

  private _filter(name: string): Users[] {
    const filterValue = name.toLowerCase();

    return this.users.filter(option => option.fullName.toLowerCase().indexOf(filterValue) === 0);
  }

  displayFn(user: Users): string {
    return user && user.fullName ? user.fullName : '';
  }

  selectUserChange(value: any) {
    this.selectedUser = value.id;
    this.getData();
  }

  getData() {
    this.spinnerOverlay = true;

    this.service.getByUser(this.selectedUser).subscribe(data => {
      this.lstCategories = data;
      this.dataSource = new MatTableDataSource(this.lstCategories);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.spinnerOverlay = false;
    }, error => {
      console.log(error);
      this.spinnerOverlay = false;
    });
  }

  save() {
    this.spinnerOverlay = true;
    var _categoryIds = [];
    for (var i = 0; i < this.lstCategories.length; i++) {

      if (!this.lstCategories[i].userPermission) {

        _categoryIds.push(this.lstCategories[i].categoryId);
      }

    }

    var obj = {
      userId: this.selectedUser,
      categoryIds: _categoryIds
    }

    this.service.Create(obj).subscribe(data => {
      this.openSnackBar(this.translate.instant("createdSuccessfully"), 'snackBarSuccess');
      this.spinnerOverlay = false;
    }, error => {
      this.spinnerOverlay = false;
      if (error.error.message != undefined) {
        this.openSnackBar(error.error.message, 'snackBarError');
      }
      else {
        this.openSnackBar("Internal server error", 'snackBarError');
      }
    })

  }

  openSnackBar(message: any, cssclass: any) {
    this.snackBar.open(message, 'X', {
      duration: 6000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: cssclass

    });
  }

}
